import BaseDataShape = require("./BaseDataShape");
import DataVisSubRenderable = require("./DataVisSubRenderable");
import PyramidDataShape = require("./PyramidDataShape");

import WorldDataElement	= require("./../../data/WorldDataElement");
import WorldDataSet	= require("./../../data/WorldDataSet");

class DataVisRenderable
{
    private _subRenderables : DataVisSubRenderable[];

    constructor(dataPoints:WorldDataSet, baseShape?:BaseDataShape)
    {
        this.init(dataPoints, baseShape || new PyramidDataShape());
    }

    get numSubRenderables() { return this._subRenderables.length; }
    getSubRenderable(index:number) { return this._subRenderables[index]; }

    private init(dataPoints:WorldDataSet, baseShape:BaseDataShape):void
    {
        // need to split data points, so there's not more than 2^16 vertices
        var baseVertices = baseShape.vertices.length;
        var maxPoints = Math.floor(65535 / baseVertices);
        var numDataPoints = dataPoints.elements.length;

        this._subRenderables = [];

        if (numDataPoints < maxPoints) {
            this.addSubRenderable(dataPoints, 0, numDataPoints, baseShape);
        }
        else {
            for (var i = 0; i < numDataPoints; i += maxPoints) {
                this.addSubRenderable(dataPoints, i, i + maxPoints, baseShape);
            }
        }
    }

    private addSubRenderable(dataPoints:WorldDataSet, start:number, end:number, baseShape:BaseDataShape)
    {
        this._subRenderables.push(new DataVisSubRenderable(dataPoints, start, end, baseShape));
    }

    public dispose():void
    {
        var len = this._subRenderables.length;
        for (var i = 0; i < len; ++i) {
            this._subRenderables[i].dispose();
        }
    }
}

export = DataVisRenderable;